import fetchJSON from '../fetchJSON'
import { SocialStatus } from '../setSocialStatus'

async function fetchSocialStatus (channelId = '', webcastId = '', hostUrl = ''): Promise<SocialStatus> {

  if (!channelId || !webcastId) return null

  const { data } = await fetchJSON('fetchSocialStatus', `${hostUrl || process.env.HOST}/service/attendee-status/channel/${channelId}/webcast/${webcastId}/socialStatus`, { includeCredentials: true })
  return data?.socialStatus || ''

}

export default fetchSocialStatus
